import React from 'react';
import { Container,AppBar,Typography } from '@material-ui/core';
import memories from '../images/memories.jpg';
import useStyles from './styles.js';

function Header(){
    const classes = useStyles();
    return (
        <>
          <Container maxWidth="lg">
              <AppBar className={classes.AppBar} position="static" color="secondary">
                  <Typography className={classes.MemoryText} variant="h3" align="center">Memories</Typography>
                  <img className={classes.Image} src={memories} alt="Memories" height="65" width="90" />
              </AppBar>
          </Container>  
        </>
    );
}

export default Header;